import { Error, ERROR_STATUS } from '@futrli/errors';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { hideAppNavBarWithLocationState } from '../../utils/routes-utils';

/**
 * Hides the app nav bar and show the 404 page.
 * @returns {JSX.Element}
 */
export const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  hideAppNavBarWithLocationState(navigate, location);

  return <Error errorStatus={ERROR_STATUS._404} />;
};
